import React from "react";
import { Image } from "react-bootstrap";
import moment from "moment";
import xCircle from "../../../assets/icons/x-circle.svg";
import phoneicon from "../../../assets/icons/phoneicon.svg";
import smsicon from "../../../assets/icons/smsicon.svg";
import gifticon from "../../../assets/icons/gifticon.svg";

const MemberInfoDetail = ({
  fetchTransChatList,
  coworkerDetails,
  handleMuteNotification,
  rightSideMenuStat,
  setRightSideMenuStat,
  setShowAdminDrop,
}) => {
  const t = (key) => fetchTransChatList?.[key] || "";
  const toggleRightSideMenu = () => {
    setRightSideMenuStat(!rightSideMenuStat);
    setShowAdminDrop(false);
  };

  return (
    <div
      className="right-sub-chat-style co_workerDetls_MOBWidth mt-2 mt-lg-0 ms-lg-0 ms-2"
      style={{ backgroundColor: "white" }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h6 className="ms-3 Group-Details-chat mt-2">
          {/* Co-worker Details */}
          {t("Co-worker Details")}
        </h6>
        <img
          src={xCircle}
          width={20}
          height={20}
          alt="#"
          onClick={toggleRightSideMenu}
          className="m-2"
        />
      </div>

      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {coworkerDetails.groupuser?.imageurl ? (
            <div
              className="profile-image"
              style={{
                border: "1px solid #707070",
                height: "83px",
                width: "83px",
                borderRadius: "50%",
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
                src={coworkerDetails.groupuser?.imageurl}
                alt=""
              />
            </div>
          ) : (
            <div
              className="co-worker-chat1"
              style={{
                fontSize: "30px",
                color: "#FFFFFF",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#95A7C6",
                height: "96px",
                width: "96px",
                borderRadius: "50%",
              }}
            >
              {coworkerDetails.groupuser?.lastname?.toUpperCase()
                ? `${coworkerDetails.groupuser?.firstname
                    .slice(0, 1)
                    .toUpperCase()}${coworkerDetails.groupuser?.lastname
                    .slice(0, 1)
                    .toUpperCase()}`
                : `${coworkerDetails.groupuser?.firstname
                    ?.slice(0, 1)
                    .toUpperCase()}${coworkerDetails.groupuser?.firstname
                    ?.slice(1, 2)
                    .toUpperCase()}`}
            </div>
          )}

          <div className="d-flex align-items-center justify-content-center my-3">
            <h3
              style={{
                color: "#333333",
                fontSize: "clamp(16px, 1vw, 18px)",
                fontWeight: "bold",
                textTransform: "capitalize",
              }}
            >
              {/* {`${coworkerDetails.groupuser?.firstname} ${coworkerDetails.groupuser?.lastname}`} */}
              {`${coworkerDetails.groupuser?.firstname}`}
            </h3>
          </div>
        </div>
      </div>

      <div
        className="General-chat-div"
        style={{
          backgroundColor: "white",
          overflowY: "auto",
          height: "71%",
          borderTopLeftRadius: "5px",
          borderTopRightRadius: "5px",
          marginTop: "10px",
        }}
      >
        <div className="mt-3 pt-3 px-3 cardli-member">
          <p className="General-chat">{t("General")}</p>
          <ContactDetail
            icon={phoneicon}
            label={coworkerDetails.groupuser?.phoneNumber}
          />
          <ContactDetail
            icon={smsicon}
            label={coworkerDetails.groupuser?.email}
          />
          {coworkerDetails.groupuser?.dateofbirth && (
            <ContactDetail
              icon={gifticon}
              label={moment(coworkerDetails.groupuser?.dateofbirth).format(
                "Do MMMM",
              )}
            />
          )}
        </div>

        <div className="mt-3 p-3 cardli-member Notifications-chat-member">
          {/* Notifications */}
          <p className="General-chat">{t("Notifications")}</p>
          {/* Turn Off */}
          <NotificationOption
            value={0}
            label={t("Turn off")}
            checked={
              !coworkerDetails.isAllowedNotification &&
              coworkerDetails.muteMinutes === 0
            }
            onChange={handleMuteNotification}
          />
          {/* Silent for 30 m */}
          <NotificationOption
            value={30}
            label={t("Silent for 30 m")}
            checked={
              !coworkerDetails.isAllowedNotification &&
              coworkerDetails.muteMinutes === 30
            }
            onChange={handleMuteNotification}
          />
          {/* Silent for 24 H */}
          <NotificationOption
            value={1440}
            label={t("Silent for 24 h")}
            checked={
              !coworkerDetails.isAllowedNotification &&
              coworkerDetails.muteMinutes === 1440
            }
            onChange={handleMuteNotification}
          />
        </div>
      </div>
    </div>
  );
};

const ContactDetail = ({ icon, label }) => (
  <div className="d-flex align-items-center gap-3 mb-2">
    <Image variant="top" className="phoneicon-custom" src={icon} />
    <div style={{ color: "#333333", fontSize: "12px", lineHeight: "17px" }}>
      {label}
    </div>
  </div>
);

const NotificationOption = ({ value, label, checked, onChange }) => (
  <div className="d-flex align-items-center gap-2">
    <div className="form-check">
      <input
        className="form-check-input"
        type="checkbox"
        value={value}
        id={`defaultCheck${value}`}
        checked={checked}
        onChange={onChange}
      />
    </div>
    <label
      htmlFor={`defaultCheck${value}`}
      style={{
        color: "#333333",
        fontSize: "14px",
        lineHeight: "17px",
        cursor: "pointer",
      }}
    >
      {label}
    </label>
  </div>
);

export default MemberInfoDetail;
